<template>
    <project-step-container
            prev-to="be_rapid_experiments_with_customers_20"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row class="pb-3">
            <b-col cols="12">
                <img width="100%" class="image-header" src="../Images/representation-experimentation.jpg" tabindex="0"
                     alt="Some kind of representation of experimentation">
            </b-col>
            <b-col cols="12" class="mt-4 simple-text" tabindex="0">
               {{getMessage(21, 'rapidexperiment-sub')}}
            </b-col>
            <b-col cols="12" class="mt-4 subtitle" tabindex="0">
               {{getMessage(21, 'rapidexperiment-sub-text')}}
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import Steps from "@/modules/BeEntrepreneurship/Utils/steps";
    import {ConflictSyn, Project} from "@/core/Utils";

    export default {
        name: "RapidExperimentsWithCustomers21",
        components: {ProjectStepContainer},
        data() {
            return {
                step: Steps.FORM_INSTRUCTIONS_TEST_COME_BACK,
            }
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index

                Project.saveProjectStep(index, this.step, stepNumber, {}, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'be_rapid_experiments_with_customers_22', params: {index}})
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
   .subtitle
        font font-sourcesans-bold
        font-size 16px
        color color-4

    +for_breakpoint(xs)
        .image-header
            height 174px
</style>

